module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-left.053fcd0d.svg";